// @flow
export const dataKey: 'balances' = 'balances';
